// removed by extract-text-webpack-plugin
module.exports = {"hidden":"NDEyI","visuallyhidden":"_2Yfnt","hide-text":"_1UDl0","center":"_3DKmD","noprint":"_1zK2f","root":"_2SXsq","contentContainer":"_3X2e5","noA":"_38YkW"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/theme/error/default.scss
 ** module id = 980
 ** module chunks = 2
 **/